export default {
    data() {
        return {
            rules: {
                pic: this.$verify.ruleEmptyStr(this.$t('请上传')),
                title: this.$verify.ruleEmptyStr(this.$t('请输入商品名')),
                contactPhone: this.$verify.ruleEmptyStr(this.$t('请输入咨询电话')),
                shengyu: this.$verify.rulePositiveInteger(this.$t('请输入剩余量，需为正整数')),
                hetong: this.$verify.ruleEmptyStr(this.$t('请上传')),
                fuwuxieyi: this.$verify.ruleEmptyStr(this.$t('请上传')),
                baozhengjine: this.$verify.rulePositiveInteger(this.$t('请输入保证金额，需为正整数')),
                status: this.$verify.ruleEmptyStr(this.$t('请选择状态')),
                jiageleixing: this.$verify.ruleEmptyStr(this.$t('请输入')),
                youxiaoqizhi: this.$verify.ruleEmptyStr(this.$t('请输入')),
                jiesuanfangshi: this.$verify.ruleEmptyStr(this.$t('请输入')),
                jiaohuodi: this.$verify.ruleEmptyStr(this.$t('请输入')),
                pinming: this.$verify.ruleEmptyStr(this.$t('请输入')),
                danwei: this.$verify.ruleEmptyStr(this.$t('请输入')),
                reliang: this.$verify.rulePositiveInteger(this.$t('请输入热量，需为正整数，单位为kcal/kg')),
            },
            toolbars: {
                autofocus: false,
                bold: true, // 粗体
                italic: true, // 斜体
                header: true, // 标题
                underline: true, // 下划线
                strikethrough: true, // 中划线
                mark: true, // 标记
                superscript: true, // 上角标
                subscript: true, // 下角标
                quote: true, // 引用
                ol: true, // 有序列表
                ul: true, // 无序列表
                link: true, // 链接
                imagelink: true, // 图片链接
                code: true, // code
                table: true, // 表格
                readmodel: true, // 沉浸式阅读
                htmlcode: true, // 展示html源码
                help: true, // 帮助
                undo: true, // 上一步
                redo: true, // 下一步
                navigation: true, // 导航目录
                alignleft: true, // 左对齐
                aligncenter: true, // 居中
                alignright: true, // 右对齐
                subfield: true, // 单双栏模式
                preview: true, // 预览
            },
            projectList: [],
            status: '',
            isCreateDialogShow: false,
            createObj: {
                fangshi: '供货',
                status: '待审核'
            },
            dictionaryList: [],
            isEditDialogShow: false,
            editObj: {

            }
        };
    },
    methods: {
        getTableData() {
            this.$http.viewProductByUser(this.$store.state.currentUser.id,this.status,'供货').then(res => {
                this.projectList = res.data;
            })
        },
        handleCreate() {
            if (this.$verify.checkIfNull(this.createObj.fudongjia) && this.$verify.checkIfNull(this.createObj.gudingjia)) {
                this.$hint.message.info('浮动价和固定价需至少填写其一');
                return;
            }
            this.$refs['createObj'].validate((valid) => {
                if (valid) {
                    this.createObj.publisherId = this.$store.state.currentUser.id;
                    this.createObj.publisherName = this.$store.state.currentUser.account;
                    this.createObj.fangshi = '供货';
                    this.$http.createProduct(this.createObj).then(res => {
                        if (res.code === 200) {
                            this.isCreateDialogShow = false;
                            this.getTableData();
                        }
                    })
                } else {
                    this.$myAnime.shakeElement('.create-btn',5);
                }
            });

        },

        beforeCoverPicUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传大小不能超过 10MB!");
            }
            return isLt2M;
        },

        onCoverPicUpload(e,obj,field) {
            let file = e.file;
            this.$http.uploadFile(file,file.name).then(res => {
                if (res.code === 200) {
                    let object = this[obj];
                    object[field] = res.data;
                    this[obj] = object;
                    this.$forceUpdate();
                    console.log(this['obj'])
                }
            })
        },

        // 编辑器中的图片上传
        editorImgUpload(pos, $file) {
            const allowedType = ['image/jpg','image/png','image/jpeg','image/gif'];

            let file = $file;

            if (!allowedType.includes(file.type)) {
                this.$hint.message.info('png/jpg/jpeg/gif');
                this.md = this.md.replace('![' + file.name + '](' + pos + ')',''); // 删除这个图片的内容
                return;
            }
            this.$http.uploadFile(file, file.name).then(res => {
                if (res.code === 200) {
                    this.$refs.md.$img2Url(pos, encodeURI(res.data));
                }
            })
        },
        viewDictionaryAll() {
            this.$http.viewDictionaryAll().then(res => {
                this.dictionaryList = res.data;
            })
        },
        handleEdit() {
            if (this.$verify.checkIfNull(this.editObj.fudongjia) && this.$verify.checkIfNull(this.editObj.gudingjia)) {
                this.$hint.message.info('浮动价和固定价需至少填写其一');
                return;
            }
            this.$refs['editObj'].validate((valid) => {
                if (valid) {
                    this.$http.updateProduct(this.editObj).then(res => {
                        if (res.code === 200) {
                            this.isEditDialogShow = false;
                            this.getTableData();
                        }
                    })
                } else {
                    this.$myAnime.shakeElement('.edit-btn',5);
                }
            });
        },
        del(item) {
            let message = this.$t('二次确认');
            this.$hint.confirm(message).then(res => {
                if (res) {
                    let obj = {
                        id: item.id,
                        status: '已下架'
                    }
                    this.$http.updateProduct(obj).then(res => {
                        if (res.code === 200) {
                            this.getTableData();
                        }
                    })
                }
            })
        },

        recover(item) {
            let message = this.$t('二次确认');
            this.$hint.confirm(message).then(res => {
                if (res) {
                    let obj = {
                        id: item.id,
                        status: '正常'
                    }
                    this.$http.updateProduct(obj).then(res => {
                        if (res.code === 200) {
                            this.getTableData();
                        }
                    })
                }
            })
        }
    },
    created() {
        this.getTableData();
        this.viewDictionaryAll();
    }
}